<template>
  <div class="arc-sec">
    <div class="arc-toolbar">
      <div class="chips">
        <button v-for="t in tipos" :key="t.v" class="chip" :class="{ on: filtro === t.v }" type="button" @click="filtro = t.v">{{ t.l }}</button>
      </div>
      <div class="spacer" />
      <button class="btn" type="button" @click="regenerate">{{ $t('ARC_MGMT.MEETINGS.REGENERATE') }}</button>
      <button class="btn primary" type="button" @click="openNew">+ {{ $t('ARC_MGMT.MEETINGS.NEW') }}</button>
    </div>

    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <table v-else>
      <tbody>
        <tr v-for="m in filtered" :key="m.id">
          <td class="cal"><b>{{ formatDate(m.inicio_em) }}</b><small>{{ formatTime(m.inicio_em) }}</small></td>
          <td>
            <b>{{ $t('ARC_MGMT.MEETINGS.TYPES.' + m.tipo) }}</b>
            <div class="ctx">{{ m.pauta }}</div>
          </td>
          <td><span class="tag" :class="m.status">{{ $t('ARC_MGMT.MEETINGS.STATUS.' + m.status) }}</span></td>
          <td class="acts"><button class="link" type="button" @click="openEdit(m)">{{ $t('ARC_MGMT.MEETINGS.OPEN') }}</button></td>
        </tr>
      </tbody>
    </table>

    <div v-if="showModal" class="arc-modal-bg" @click.self="close">
      <div class="arc-modal wide">
        <h3>{{ editing.id ? $t('ARC_MGMT.MEETINGS.OPEN') : $t('ARC_MGMT.MEETINGS.NEW') }}</h3>
        <div class="row">
          <label>{{ $t('ARC_MGMT.MEETINGS.TYPE') }}
            <select v-model="editing.tipo"><option value="semanal">Semanal</option><option value="mensal">Mensal</option><option value="trimestral">Trimestral</option><option value="avulsa">Avulsa</option></select>
          </label>
          <label>{{ $t('ARC_MGMT.MEETINGS.WHEN') }}<input v-model="editing.inicio_em" type="datetime-local" /></label>
          <label>{{ $t('ARC_MGMT.MEETINGS.DURATION') }}<input v-model.number="editing.duracao_min" type="number" min="0" /></label>
          <label>{{ $t('ARC_MGMT.MEETINGS.STATUS_LBL') }}
            <select v-model="editing.status"><option value="agendada">Agendada</option><option value="realizada">Realizada</option><option value="cancelada">Cancelada</option><option value="remarcada">Remarcada</option></select>
          </label>
        </div>
        <label>{{ $t('ARC_MGMT.MEETINGS.AGENDA') }}<input v-model="editing.pauta" type="text" /></label>
        <label>{{ $t('ARC_MGMT.MEETINGS.LINK') }}<input v-model="editing.link" type="text" /></label>
        <label>{{ $t('ARC_MGMT.MEETINGS.MINUTES') }}<textarea v-model="editing.ata" rows="4" /></label>

        <div v-if="editing.id" class="parts">
          <h4>{{ $t('ARC_MGMT.MEETINGS.PARTICIPANTS') }}</h4>
          <div v-for="p in editing.participantes" :key="p.id" class="part">
            <span>{{ agentName(p.user_id) }} <em>({{ p.lado }})</em></span>
            <label class="chk"><input type="checkbox" :checked="p.presente" @change="togglePresence(p, $event.target.checked)" /> {{ $t('ARC_MGMT.MEETINGS.PRESENT') }}</label>
            <button class="link danger" type="button" @click="removeParticipant(p)">×</button>
          </div>
          <div class="add-part">
            <select v-model="newParticipant">
              <option :value="null">{{ $t('ARC_MGMT.MEETINGS.ADD_PARTICIPANT') }}</option>
              <option v-for="a in agents" :key="a.id" :value="a.id">{{ a.name }}</option>
            </select>
            <button class="btn sm" type="button" :disabled="!newParticipant" @click="addParticipant">{{ $t('ARC_MGMT.ADD') }}</button>
          </div>
        </div>

        <div class="modal-actions">
          <button v-if="editing.id" class="btn" type="button" @click="registerDecision">{{ $t('ARC_MGMT.MEETINGS.REGISTER_DECISION') }}</button>
          <button v-if="editing.id" class="btn danger-ghost" type="button" @click="remove">{{ $t('ARC_MGMT.DELETE') }}</button>
          <div class="spacer" />
          <button class="btn" type="button" @click="close">{{ $t('ARC_MGMT.CANCEL') }}</button>
          <button class="btn primary" type="button" @click="save">{{ $t('ARC_MGMT.SAVE') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ArcAPI from 'dashboard/api/arc';

export default {
  props: { journey: { type: Object, default: () => ({}) } },
  data() {
    return {
      items: [], loading: true, filtro: 'all', showModal: false, editing: {}, newParticipant: null,
      tipos: [{ v: 'all', l: 'Todas' }, { v: 'semanal', l: 'Semanais' }, { v: 'mensal', l: 'Mensais' }, { v: 'trimestral', l: 'Trimestrais' }, { v: 'avulsa', l: 'Avulsas' }],
    };
  },
  computed: {
    ...mapGetters({ agents: 'agents/getAgents' }),
    filtered() { return this.filtro === 'all' ? this.items : this.items.filter(m => m.tipo === this.filtro); },
  },
  mounted() { this.load(); this.$store.dispatch('agents/get'); },
  methods: {
    async load() { this.loading = true; try { const { data } = await ArcAPI.meetings(); this.items = data.payload || []; } finally { this.loading = false; } },
    formatDate(iso) { return iso ? new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : ''; },
    formatTime(iso) { return iso ? new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''; },
    agentName(id) { const a = (this.agents || []).find(x => x.id === id); return a ? a.name : `#${id}`; },
    openNew() { this.editing = { tipo: 'avulsa', status: 'agendada', inicio_em: new Date().toISOString().slice(0, 16), duracao_min: 30 }; this.showModal = true; },
    async openEdit(m) { const { data } = await ArcAPI.showMeeting(m.id); this.editing = { ...data, inicio_em: (data.inicio_em || '').slice(0, 16) }; this.showModal = true; },
    close() { this.showModal = false; },
    async save() {
      const p = (({ tipo, inicio_em, duracao_min, pauta, link, ata, status }) => ({ tipo, inicio_em, duracao_min, pauta, link, ata, status }))(this.editing);
      if (this.editing.id) await ArcAPI.updateMeeting(this.editing.id, p); else await ArcAPI.createMeeting(p);
      this.close(); this.load();
    },
    async remove() { if (!window.confirm(this.$t('ARC_MGMT.DELETE') + '?')) return; await ArcAPI.deleteMeeting(this.editing.id); this.close(); this.load(); },
    async regenerate() { await ArcAPI.regenerateMeetings(); this.load(); },
    async addParticipant() {
      const { data } = await ArcAPI.addParticipant(this.editing.id, { user_id: this.newParticipant, lado: 'cliente', presente: false });
      this.editing.participantes = [...(this.editing.participantes || []), data]; this.newParticipant = null;
    },
    async togglePresence(p, presente) { await ArcAPI.updateParticipant(this.editing.id, p.id, { presente }); p.presente = presente; },
    async removeParticipant(p) { await ArcAPI.removeParticipant(this.editing.id, p.id); this.editing.participantes = this.editing.participantes.filter(x => x.id !== p.id); },
    async registerDecision() {
      const texto = window.prompt(this.$t('ARC_MGMT.MEETINGS.DECISION_PROMPT'));
      if (!texto) return;
      await ArcAPI.createDecision({ meeting_id: this.editing.id, data: new Date().toISOString().slice(0, 10), texto });
      window.alert(this.$t('ARC_MGMT.MEETINGS.DECISION_SAVED'));
    },
  },
};
</script>

<style lang="scss" scoped>
.arc-toolbar { display: flex; align-items: center; gap: var(--space-small); margin-bottom: var(--space-normal); flex-wrap: wrap; }
.spacer { flex: 1; } .chips { display: flex; gap: var(--space-micro); } .muted { color: var(--s-500); }
.chip { border: 1px solid var(--s-200); background: var(--white); border-radius: 9999px; padding: var(--space-micro) var(--space-small); font-size: var(--font-size-mini); color: var(--s-600); cursor: pointer; &.on { background: var(--s-800); border-color: var(--s-800); color: var(--white); } }
table { width: 100%; border-collapse: collapse; }
td { padding: var(--space-small); border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-800); vertical-align: middle; }
.cal { width: 5rem; text-align: center; b { display: block; } small { color: var(--s-400); font-size: var(--font-size-mini); } }
.ctx { color: var(--s-500); font-size: var(--font-size-mini); margin-top: var(--space-micro); }
.tag { font-size: var(--font-size-mini); padding: var(--space-micro) var(--space-small); border-radius: 9999px; background: var(--s-75); color: var(--s-600);
  &.realizada { background: var(--g-100); color: var(--g-700); } &.cancelada { background: var(--r-100); color: var(--r-600); } }
.acts { text-align: right; }
.link { border: 0; background: none; color: var(--w-600); font-size: var(--font-size-mini); cursor: pointer; &.danger { color: var(--r-500); } }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer;
  &.sm { height: var(--space-medium); font-size: var(--font-size-mini); } &.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); } &.danger-ghost { border-color: var(--r-200); color: var(--r-500); } }
.arc-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: grid; place-items: center; z-index: 9999; }
.arc-modal { background: var(--white); border-radius: var(--border-radius-large); padding: var(--space-large); width: 34rem; max-width: 92vw; max-height: 90vh; overflow: auto;
  &.wide { width: 40rem; } h3 { margin: 0 0 var(--space-normal); color: var(--s-900); }
  label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); margin-bottom: var(--space-small); }
  input, textarea, select { border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: var(--space-smaller) var(--space-small); background: var(--white); color: var(--s-800); }
  .row { display: grid; grid-template-columns: 1fr 1.4fr 1fr 1fr; gap: var(--space-small); } }
.parts { border-top: 1px solid var(--s-100); margin-top: var(--space-small); padding-top: var(--space-small); h4 { font-size: var(--font-size-small); color: var(--s-600); margin: 0 0 var(--space-small); } }
.part { display: flex; align-items: center; gap: var(--space-normal); font-size: var(--font-size-small); padding: var(--space-micro) 0; em { color: var(--s-400); } }
.part .chk { flex-direction: row; align-items: center; gap: var(--space-micro); margin: 0; }
.add-part { display: flex; gap: var(--space-small); margin-top: var(--space-small); }
.modal-actions { display: flex; align-items: center; gap: var(--space-small); margin-top: var(--space-normal); }
</style>
